export const DEFAULT_HEIGHT_CONTAINER = 40
export const DEFAULT_HEIGHT_CONTAINER_SMALL = 20
